export const getAssetSourceFilterStyle = () => ({
  importSourceFilterDowndown: {
    padding: 24,
    pointerEvents: 'auto',

    '& .dropdown-title': {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: '20px',
    },
  },
});
